export const order = ["FINISHED", "READY"];
